import { req } from "../@api/request";

export default class LoanCommonInfoService {
  static commonInfo = async (
    c_idx: string,
  ) => {
      const result = await req.get(
        `/loan/info/common?c_idx=${c_idx}`,
      );
      return result.data;
   
  };

}
